export default __webpack_public_path__ + "static/media/leftPanel.91fd17aa.png";